//                                   0, 1, 2,  3,  4,  5,  6,  7,  8,  9, 10, 11
export const spacingThemeOverride = [0, 4, 8, 16, 24, 32, 40, 48, 56, 64, 72, 80] as const;
export type SpacingUnitsT = keyof typeof spacingThemeOverride;
